import {
	Component,
	OnInit,
	ViewEncapsulation,
	Input,
	EventEmitter,
	Output,
	HostListener,
  ElementRef,
} from '@angular/core';
import {FnEventFilter,FnFilterOption} from './fn-event-filter.model';
@Component({
	selector: 'fn-event-filter',
	templateUrl: './fn-event-filter.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class FnEventFilterComponent implements OnInit {
	/**
	 * Array FnEventFilter to show on Filter
	 */
	@Input() eventFilterArray: Array<FnEventFilter>;
	/**
	 * Text to show on Filter
	 */
	@Input() filterText = 'Filter';
	/**
	 * Emit event when Apply or rest filter button clicked
	 */
	@Output() actionOnFilter = new EventEmitter<boolean>();
	/**
	 * clone Array used to assign when user close filter after
	 * changing selected Element without clicking on Apply or close button
	 */
	private clonedFilterArray: Array<FnEventFilter>;
	/**
	 * object to bind properties on ui
	 */
	uiEventFilterMap = {
		isClearDisabled: true,
		isApplyDisabled: true,
		isFilterApply: false,
		isOpenDropDown: false,
		fnBtnClass :'btn-sm btn-round btn-outline-secondary dropdown-toggle',
		fnBtnIconClass :'global-filter'
  };
  /**
   * used to store button class before Filter apply
   */
  private btnClassBeforeFilterApply = 'btn-sm btn-round btn-outline-secondary dropdown-toggle ';
  /**
   * * used to store button icon class before Filter apply
   */
  private btnIconClassBeforeFilterApply ='global-filter';

	/**
	 * Creates an instance of fn event filter component.
	 * @param elemRef ElementRef ref
	 */
	constructor(private elemRef:ElementRef) {}

	/**
	 * Implementing on Init Method;
	 * set default filter Class
	 */
	ngOnInit() {
		this.uiEventFilterMap.fnBtnClass = this.btnClassBeforeFilterApply;
		this.uiEventFilterMap.fnBtnIconClass = this.btnIconClassBeforeFilterApply;
	}

	/**
	 * Method to Apply  Rest Event Filter
	 * @param isFilterApply boolean value if true then filter applied
	 */
	applyOrResetFilter(isFilterApply: boolean) {
		this.uiEventFilterMap.isClearDisabled = isFilterApply;
		this.uiEventFilterMap.isFilterApply = isFilterApply;
		this.uiEventFilterMap.isOpenDropDown = isFilterApply;
		this.uiEventFilterMap.isClearDisabled = !isFilterApply;
		this.changeFilterButtonClass();
		this.showOrHideDropDown(false,false);
        this.actionOnFilter.emit(isFilterApply);
	}

	/**
	 * Method to ser Action option and Enable Apply button when user select any other elements
	 * @param event Event ref
	 * @param fnEventFilter Event filter Object
	 * @param fnFilterOption that is checked by user and set as activeOption
	 */
	enableAccept(
		event: Event,
		fnEventFilter: FnEventFilter,
		fnFilterOption: FnFilterOption
	) {
		if (fnFilterOption.isDefaultOption) {
			delete fnEventFilter.activeOption;
		} else {
			fnEventFilter.activeOption = fnFilterOption;
		}
		this.uiEventFilterMap.isApplyDisabled = false;
	}

	/**
	 * Method used to open and close Drop Down
	 * @param isToOpen boolean value if False then filter opens else closed
	 * @param isToRestFilter Optional value to rest filter to prev state when user
	 * close dropdown when appy or reset button is not clicked
	 */
	showOrHideDropDown(isToOpen: boolean , isToRestFilter?:boolean) {
		this.uiEventFilterMap.isApplyDisabled = true;
		this.uiEventFilterMap.isOpenDropDown = isToOpen;
		if (!isToOpen && isToRestFilter) {
			this.eventFilterArray = this.clonedFilterArray;
		} else if(isToOpen){
			this.clonedFilterArray = this.clonedArray(this.eventFilterArray);
		}
	}
	/**
	 * priavte method to change class when filter is Applied or reset
	 */
	private changeFilterButtonClass(){
		if(this.uiEventFilterMap.isFilterApply){
			this.uiEventFilterMap.fnBtnClass = this.btnClassBeforeFilterApply+' filter-on';
			this.uiEventFilterMap.fnBtnIconClass = this.btnIconClassBeforeFilterApply +' blue';
		}
		else{
			this.uiEventFilterMap.fnBtnClass = this.btnClassBeforeFilterApply;
			this.uiEventFilterMap.fnBtnIconClass = this.btnIconClassBeforeFilterApply;
		}
	}
	/**
	 * Hosts listener to cose dropdown when user click outside Filter Component
	 * @param event Event ref to check user click outside Filter Component
	 */
	@HostListener('document:click', ['$event'])
	clickout(event: Event) {
    if(!this.elemRef.nativeElement.contains(event.target) && this.uiEventFilterMap.isOpenDropDown){
      this.showOrHideDropDown(false,true);
      event.stopPropagation();
    }
	}
	/**
	 * Method to create new FnEventFilter array
	 * @param arrayToClone array to create new Array
	 * @returns newly created array
	 */
	private clonedArray(arrayToClone: Array<FnEventFilter>) {
		return arrayToClone.map(value => {
			return Object.assign({}, value);
		});
	}
}
